var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-file',{staticClass:"file-field",attrs:{"placeholder":_vm.$t('applications.new.choose-file')},on:{"input":_vm.handleChooseFile},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})
}
var staticRenderFns = []

export { render, staticRenderFns }